import { textColumn } from '@/shared/grids/columns/textColumn';
import { GridColumnSettings } from '@/shared/types/grid';
import { charityRegisterUrl } from '@/shared/utils/url';

export const charityNumberColumn = <
  T extends {
    charityNumber?: string | null;
    organisationType?: string | null;
    registrationNumber?: string | null;
  },
>(options: {
  uid?: string;
  field: keyof T & string;
  chooserName?: string;
  visible?: boolean;
}): GridColumnSettings<T> => {
  const { uid, field, chooserName, visible } = options;

  return textColumn({
    uid,
    field,
    header: 'Charity Number',
    visible,
    template: (data: T) => {
      const charityNumber = data.charityNumber;
      if (!charityNumber) {
        return '<span class="text-more-muted">Not set</span>';
      }

      const url = charityRegisterUrl(charityNumber, data.organisationType, data.registrationNumber);
      if (!url) {
        return charityNumber;
      }

      return `<a href="${url}" target="_blank" class="grid-link">${charityNumber}</a>`;
    },
    chooserName,
  });
};
